import { z } from "zod";

export const valueSchema = z.union([z.boolean(), z.number(), z.string()]);

export const flagSchema = z.array(
  z.object({ name: z.string(), value: valueSchema })
);

export type Flags = z.infer<typeof flagSchema>;

export type Flag = Flags[number];

export const storageName = "_featureFlagOverride";

export function getType(
  input: string | boolean | number
): "string" | "boolean" | "number" {
  if (typeof input === "boolean") {
    return "boolean";
  }

  if (typeof input === "number") {
    return "number";
  }

  if (typeof input === "string") {
    if (input.toLowerCase() === "true" || input.toLowerCase() === "false") {
      return "boolean";
    }

    if (!isNaN(Number(input)) && input.trim() !== "") {
      return "number";
    }

    return "string";
  }

  throw new Error("Unexpected input type");
}
